export default {"src":"/_next/static/media/fluxLogoWithText.31e93b42.svg","height":40,"width":121,"blurWidth":0,"blurHeight":0};